import { Box } from "@mantine/core"
import { useState } from "react"
import { AppTitle, Markdown } from "@/components/utils"
import type { TSurveyQuestion } from "@/types"
import { QuestionBoolean } from "./QuestionBoolean"
import { QuestionDate } from "./QuestionDate"
import { QuestionLikert } from "./QuestionLikert"
import { QuestionMultiple } from "./QuestionMultiple"
import { QuestionNumber } from "./QuestionNumber"
import { QuestionPersonal } from "./QuestionPersonal"
import { QuestionScale } from "./QuestionScale"
import { QuestionSelect } from "./QuestionSelect"
import { QuestionString } from "./QuestionString"
import { QuestionTags } from "./QuestionTags"

export function QuestionPreview({ question }: { question: TSurveyQuestion }) {
  const { type } = question
  const [value, setValue] = useState<any>(null)
  const props = {
    question,
    value,
    setValue,
    preview: true,
    comment: value,
    setComment: setValue,
  }

  return (
    <Box>
      <AppTitle fz={22} mb="sm" gap={0}>
        {question.title}
        {question.note && (
          <Markdown c="dimmed" fz="sm" w="100%">
            {question.note}
          </Markdown>
        )}
      </AppTitle>

      <Box>
        {type == "likert" ? (
          <QuestionLikert {...props} />
        ) : type == "scale" ? (
          <QuestionScale {...props} />
        ) : type == "string" ? (
          <QuestionString {...props} />
        ) : type == "personal" ? (
          <QuestionPersonal {...props} />
        ) : type == "date" ? (
          <QuestionDate {...props} />
        ) : type == "tags" ? (
          <QuestionTags {...props} />
        ) : type == "select" ? (
          <QuestionSelect {...props} />
        ) : type == "multiple" ? (
          <QuestionMultiple {...props} />
        ) : type == "boolean" ? (
          <QuestionBoolean {...props} />
        ) : type == "number" ? (
          <QuestionNumber {...props} />
        ) : null}
      </Box>
    </Box>
  )
}
